import React, { useState } from 'react';
import { Phone, MessageCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { businessInfo } from '../mock/data';

const ContactButtons = () => {
  const [isPhoneOpen, setIsPhoneOpen] = useState(false);
  const [isWhatsAppOpen, setIsWhatsAppOpen] = useState(false);

  const formatPhoneForLink = (phone) => {
    return phone.replace(/\s/g, '');
  };

  const formatPhoneForWhatsApp = (phone) => {
    return phone.replace(/\s/g, '').replace(/\+/g, '');
  };

  return (
    <div className="flex items-center justify-center space-x-3">
      {/* Phone Dropdown */}
      <div className="relative">
        <button
          onClick={() => {
            setIsPhoneOpen(!isPhoneOpen);
            setIsWhatsAppOpen(false);
          }}
          className="flex items-center space-x-2 px-4 py-2.5 bg-[var(--gold)] text-black font-semibold rounded-lg hover:bg-[var(--gold-light)] transition-all duration-300 shadow-lg"
        >
          <Phone size={18} />
          <span className="hidden sm:inline">Telefon</span>
          {isPhoneOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </button>

        {isPhoneOpen && (
          <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 md:left-auto md:right-0 md:translate-x-0 glass rounded-lg shadow-2xl overflow-hidden min-w-[250px] animate-in slide-in-from-top-2 z-50">
            {businessInfo.phones.map((phone, index) => (
              <a
                key={index}
                href={`tel:${formatPhoneForLink(phone)}`}
                className="flex items-center space-x-3 px-4 py-3 hover:bg-[var(--dark-secondary)] transition-colors duration-200 border-b border-gray-700 last:border-b-0"
                onClick={() => { window.gtag_report_conversion && window.gtag_report_conversion(`tel:${formatPhoneForLink(phone)}`); setIsPhoneOpen(false); }}
              >
                <Phone size={16} className="text-[var(--gold)]" />
                <span className="text-sm text-gray-200 font-medium">{phone}</span>
              </a>
            ))}
          </div>
        )}
      </div>

      {/* WhatsApp Dropdown */}
      <div className="relative">
        <button
          onClick={() => {
            setIsWhatsAppOpen(!isWhatsAppOpen);
            setIsPhoneOpen(false);
          }}
          className="flex items-center space-x-2 px-4 py-2.5 bg-[#25D366] text-white font-semibold rounded-lg hover:bg-[#20BA5A] transition-all duration-300 shadow-lg"
        >
          <MessageCircle size={18} />
          <span className="hidden sm:inline">WhatsApp</span>
          {isWhatsAppOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </button>

        {isWhatsAppOpen && (
          <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 md:left-auto md:right-0 md:translate-x-0 glass rounded-lg shadow-2xl overflow-hidden min-w-[250px] animate-in slide-in-from-top-2 z-50">
            {businessInfo.phones.map((phone, index) => (
              <a
                key={index}
                href={`https://wa.me/${formatPhoneForWhatsApp(phone)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 px-4 py-3 hover:bg-[var(--dark-secondary)] transition-colors duration-200 border-b border-gray-700 last:border-b-0"
                onClick={() => setIsWhatsAppOpen(false)}
              >
                <MessageCircle size={16} className="text-[#25D366]" />
                <span className="text-sm text-gray-200 font-medium">{phone}</span>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactButtons;